import React, { useEffect } from 'react';
import RetailOrderGrid from '../../../features/dealer/retail-order-grid/components/RetailOrderGrid';
import { useTitle } from "../../../contexts/title";
import OrderTypeSelector from '../../../features/dealer/order-type-selector/components/OrderTypeSelector';

export default function RetailOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Retail Orders')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<OrderTypeSelector />

				<RetailOrderGrid
					vanityOrders={false}
					imeOrders={false}
				/>
			</div>
		</React.Fragment>
	)
} 
